import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getCookie } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { checkValidity } from '../../helpers/helpers.js'

// Components
import Step from '../Common/Step';
import RegisterStep from './RegisterStep';

const RegisterForm = observer(class RegisterForm extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      step: this.props.step || 1
    }

    // Retrieve data from localStorage
    let registerData = null;

    if(SessionStore.hasSessionStorage) {
      registerData = sessionStorage.getItem('registerData');
    } else {
      registerData = getCookie('registerData');
    }

    if(registerData && typeof registerData !== 'undefined') {
      this.props.store.RegisterStore.getLocalStorage(JSON.parse(registerData));
    } else {
      this.props.store.RegisterStore.getProctorData();
    }
  }

  setStep(e, step) {
    e.preventDefault();

    this.setState({
      step
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    const _this = this;

    setTimeout(function(){
      _this.props.routing.history.push('/register/step-0' + (_this.state.step + 1));
    });

    // this.setState({
    //   step: this.state.step + 1
    // });

    window.scrollTo(0, 0);
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });

    this.props.routing.history.push('/register/step-0' + (this.state.step - 1));
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  render() {
    const { translation } = this.props;

    return(
      <div className={`wrap block-form ${this.state.step === 2 ? 'block-form--alt' : 'no'}`}>
        <Step step={this.state.step} setStep={this.setStep} data={translation.steps} skippable={false} />

        <RegisterStep step={this.state.step} checkValidity={checkValidity} nextStep={this.nextStep} prevStep={this.prevStep} {...this.props} />
      </div>
    );
  }
})

export default translate('RegisterForm')(RegisterForm);


// WEBPACK FOOTER //
// ./src/app/components/Register/RegisterForm.js